import React, { useRef, useState } from "react";
import { CopyTextIcon, LikeIcon, DislikeIcon } from "../../../assets/images/svg";
import FeedbackPopover from "./FeedbackPopover";

const extractHtml = (response) => {
  if (Array.isArray(response)) {
    return response
      .filter((block) => block.type === "text")
      .map((block) => block.content || "")
      .join("\n");
  }
  return response || "";
};

const copyText = (response) => {
  if (!response) return;

  const temp = document.createElement("div");
  temp.innerHTML = extractHtml(response);

  let text = temp.innerText;

  text = text
    .replace(/\n{3,}/g, "\n\n")
    .replace(/\u2022/g, "•")
    .trim();

  navigator.clipboard
    .writeText(text)
    .then(() => {})
    .catch((err) => {
      console.error("error:", err);
    });
};
const Feedback = ({ message, id, pageName, feedback }) => {
  const [draftFeedback, setDraftFeedback] = useState(null);
  const [popoverFeedback, setPopoverFeedback] = useState(null);

  const dislikeButtonRef = useRef(null);
  const likeButtonRef = useRef(null);

  const anchorRefMap = {
    positive: likeButtonRef,
    negative: dislikeButtonRef
  };

  const activeFeedback = draftFeedback ?? feedback;

  const handleClick = (value) => {
    if (activeFeedback === value) return;

    setDraftFeedback(value);
    setPopoverFeedback(value);
  };

  const handleSubmit = () => {
    setDraftFeedback(null);
    setPopoverFeedback(null);
  };

  const handleClose = () => {
    setDraftFeedback(null);
    setPopoverFeedback(null);
  };

  return (
    <div className="feedback">
      Was this helpful?
      <div className="feedback__actions">
        <button
          type="button"
          className="feedback__action feedback__action--copy"
          onClick={() => copyText(message)}
        >
          <CopyTextIcon />
        </button>

        <button
          ref={likeButtonRef}
          type="button"
          className={`feedback__action feedback__action--like ${
            activeFeedback === "positive" ? "active" : ""
          }`}
          onClick={() => handleClick("positive")}
          data-testid="feedback-like-button"
        >
          <LikeIcon />
        </button>

        <button
          ref={dislikeButtonRef}
          type="button"
          className={`feedback__action feedback__action--dislike ${
            activeFeedback === "negative" ? "active" : ""
          }`}
          onClick={() => handleClick("negative")}
          data-testid="feedback-dislike-button"
        >
          <DislikeIcon />
        </button>
      </div>
      {popoverFeedback && (
        <FeedbackPopover
          feedback={popoverFeedback}
          anchorRef={anchorRefMap[popoverFeedback]}
          pageName={pageName}
          id={id}
          onClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default Feedback;
